import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../App';
import axios from 'axios';
import { getHeaders, headers } from '../../http/axios';

export default function EditCategory() {
    const imageUrl = "./assets/images/";
    const navigate = useNavigate();
    const { id } = useParams();
    const { setSpinner } = useContext(GlobalContext);
    const location = useLocation();
    const categoryData = location.state?.categoryData;
    const handleBackClick = () => {
        navigate(-1);
    };
    // -----use form login validation ----
    const {
        register, reset, handleSubmit, setValue, formState: { errors }, } = useForm({
            mode: "all",
        });
    useEffect(() => {
        if (categoryData) {
            console.log("Category Data:", categoryData); // Debugging line
            reset({
                name: categoryData.name,
                section: categoryData.section,
                description: categoryData.content,
            });
        } else {
            toast.error("No category data available");
            navigate("/category"); // Go back if no category data is found
        }
    }, [categoryData, reset, navigate]);

    // --------------- * eeditt Category
    const addCategory = async (data) => {
        setSpinner(true);
        try {
            const finalResponse = await axios.put(
                `${process.env.REACT_APP_API_KEY}blog/categories/${id}`,
                {
                    name: data.name,
                    section: data.section,
                    content: data.content,
                },
                {
                    headers: getHeaders(),
                }

            );
            toast.success(finalResponse.data.message);
            navigate("/category");
        } catch (error) {
            toast.error(error.response.data.message);
        } finally {
            setSpinner(false);
        }
    };
    return (
        <div className="admin-form">
            <div className="title flex justify-start items-center mb-8 gap-4">
                <div className="bg-white py-3 px-4 rounded-[6px] shadow pointer" onClick={handleBackClick}>
                    <img src={imageUrl + "back.svg"} alt="" />
                </div>
                <h2>
                    {id ? "Edit " : "Add "} Blog Category</h2>
            </div>

            <div className="data-box ">
                <div className="p-8 ">
                    <form onSubmit={handleSubmit(addCategory)}>
                        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div class="col-span-full ">
                                <label for="category-name" class="block text-sm font-medium leading-6 text-gray-900">Category Name <span className='text-[red]'>*</span></label>
                                <div class="mt-3 input-box">
                                    <input type="text"  {...register("name", { required: true })} name="name" id="category-name" placeholder='Enter category name'
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6" />
                                </div>
                                {errors.name && <span className='text-xs text-[red]'>This field is required</span>}
                            </div>
                            <div class="col-span-full ">
                                <label for="section-name" class="block text-sm font-medium leading-6 text-gray-900">Section </label>
                                <div class="mt-3 input-box">
                                    <input type="text"  {...register("section")} name="section" id="section-name" placeholder='Enter section name'
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6" />
                                </div>
                            </div>
                            {/* <div class="col-span-full">
                                <label for="about" class="block text-sm font-medium leading-6 text-gray-900">Description</label>
                                <div class="mt-3 input-box">
                                    <textarea id="about" name="about" rows="5"{...register("description")} placeholder='Enter categor description'
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6"></textarea>
                                </div>
                            </div> */}

                        </div>


                        <div class="flex items-center justify-between">
                            <button class="btn mt-8 w-2/12 text-center text-base">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div >
    )
}
